import { StakeLog } from 'types';
import { restService } from 'utilities';

export interface GetStakeLogsInput {
  user?: string;
  fromBlock?: number;
  toBlock?: number | 'latest';
  limit?: number;
}

export interface GetStakeLogsOutput {
  logs: StakeLog[];
}

const getStakeLogs = async ({
  user,
  fromBlock,
  toBlock = 'latest',
  limit = 50,
}: GetStakeLogsInput = {}): Promise<GetStakeLogsOutput> => {
  try {
    const params: Record<string, any> = {
      limit,
    };

    if (user) params.user = user;
    if (fromBlock) params.fromBlock = fromBlock;
    if (toBlock) params.toBlock = toBlock;

    const response = await restService<any>({
      endpoint: '/logs/stakes',
      method: 'GET',
      params,
    });

    // Return empty array if no response
    if (!response?.data) {
      return { logs: [] };
    }

    // Check if data is directly an array
    if (Array.isArray(response.data)) {
      return { logs: response.data };
    }

    // Check if response has nested data array
    if (response.data.data && Array.isArray(response.data.data)) {
      return { logs: response.data.data };
    }

    // Fallback: return empty array
    return { logs: [] };
  } catch (error) {
    console.error('Error fetching stake logs:', error);
    return { logs: [] };
  }
};

export default getStakeLogs;
